import HowToArticle from 'components/articles/HowToArticle';
import { Link as MuiLink } from '@material-ui/core';
import { Link } from 'react-router-dom';
import convertImage from 'components/articles/how-to-convert-an-image.png';
import Hint from 'components/articles/Hint';

const image = {
  src: convertImage,
  width: 1060,
  height: 430,
  alt: 'PhotoUtils screenshot: how to convert PNG to JPG',
  title: 'How to convert an image online using PhotoUtils',
  type: 'image/png',
};

function HowToConvert() {
  return (
    <HowToArticle
      action="convert"
      description="How to convert a picture between different formats using online image converter. Convert JPG to PNG, PNG to JPG any many more right in your browser."
      image={image}
      publishedTime={'2020-11-27T13:27:38'}
      modifiedTime={'2020-11-27T13:27:38'}
    >
      Sometimes you need to convert a picture between different file formats. For example, <strong>JPG to PNG</strong>
      {', '}
      <strong>PNG to JPG</strong>, <strong>JPG to WEBP</strong> and so on. There are many ways to do it, but what if you
      don't want to open big and heavy Photoshop for such a utility task? The simplest option is to use an online image
      converter, such as PhotoUtils. It's free to use and supports most of the popular formats. To convert your picture
      follow these 3 simple steps:
      <ol>
        <li>
          Upload your picture on{' '}
          <MuiLink to="/" component={Link}>
            PhotoUtils home page
          </MuiLink>{' '}
          and switch to the <strong>Convert</strong> tool
        </li>
        <li>Select a destination file format</li>
        <li>
          Click <strong>Convert</strong> to download the result
        </li>
      </ol>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img {...image} />
      <Hint>
        PhotoUtils can convert between 7 popular formats: <strong>JPG, PNG, WEBP, GIF, ICO, BMP, TIFF</strong>
      </Hint>
    </HowToArticle>
  );
}

export default HowToConvert;
